module.exports = __webpack_public_path__ + "static/media/(000296).bbeb17c5.jpg";